import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { WalkOutAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-walk-out-slot',
    templateUrl: './walk-out-slot.component.html',
    styleUrl: './walk-out-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WalkOutSlotComponent implements SheetSlotComponentBase {

	@Input() action!: WalkOutAction;
	value = null;

	constructor() {
	}
}
